import type { Translator } from '@porotutu/i18n'
import type { FilterSelectSpec } from '@porotutu/react/components/FilterBar/FilterBar'
import { assignableRolesFor } from '../../vocabulary'
import type { ManagedUserListQuery } from '../queries'

export const filtersFor = (t: Translator, query: ManagedUserListQuery): FilterSelectSpec[] => {
  const roles = assignableRolesFor(query.realm)

  if (roles.length === 0) return []

  return [
    {
      name: 'role',
      label: t('adm.users.filters.role_blank'),
      value: String(query.role ?? ''),
      options: roles.map((role) => ({ value: role, label: t(`adm.users.roles.${role}`) })),
    },
  ]
}
